export default "__VITE_ASSET__0ceb633f__"